export default "__VITE_ASSET__DIHN3OY___"